"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1672],{

/***/ 68590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34237);


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var fontSizes = {
    h4: [
        '14px',
        '14px',
        '16px',
        '16px'
    ],
    h3: [
        '16px',
        '16px',
        '20px',
        '20px'
    ],
    h2: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h1: [
        '36px',
        '36px',
        '36px',
        '36px'
    ]
};
var boostFontSizes = {
    h4: [
        '28px',
        '28px',
        '28px',
        '28px'
    ],
    h3: [
        '40px',
        '40px',
        '48px',
        '48px'
    ],
    h2: [
        '48px',
        '48px',
        '60px',
        '60px'
    ],
    h1: [
        '60px',
        '60px',
        '68px',
        '68px'
    ]
};
var fontWeights = {
    h4: '500',
    h3: '500',
    h2: '600',
    h1: '600'
};
var Heading = function(_param) /*#__PURE__*/ {
    var children = _param.children, _format = _param.format, format = _format === void 0 ? 'h1' : _format, _boostSizeLength = _param.boostSizeLength, boostSizeLength = _boostSizeLength === void 0 ? 0 : _boostSizeLength, _pt = _param.pt, pt = _pt === void 0 ? 2 : _pt, _mt = _param.mt, mt = _mt === void 0 ? 2 : _mt, props = _objectWithoutProperties(_param, [
        "children",
        "format",
        "boostSizeLength",
        "pt",
        "mt"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Heading */ .X6, _objectSpread({
        as: format,
        fontSize: boostSizeLength ? boostFontSizes[format] : fontSizes[format] || fontSizes.h1,
        fontWeight: fontWeights[format] || fontWeights.h1,
        letterSpacing: "1px",
        color: "text.100",
        lineHeight: "normal",
        "data-testid": "heading",
        pt: pt,
        mt: mt
    }, props, {
        children: boostSizeLength && children ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                children.slice(0, boostSizeLength),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
                    display: "inline",
                    fontSize: fontSizes[format] || fontSizes.h1,
                    children: children.slice(boostSizeLength)
                })
            ]
        }) : children
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Heading);


/***/ }),

/***/ 82452:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ Link; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8014);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75657);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34237);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95196);
/* harmony import */ var react_icons_hi__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48470);




function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Link = function(_param) /*#__PURE__*/ {
    var href = _param.href, external = _param.external, children = _param.children, props = _objectWithoutProperties(_param, [
        "href",
        "external",
        "children"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
        children: external === true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            target: "_blank",
            href: href,
            rel: "noopener noreferrer",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                alignItems: "flex-start",
                cursor: "pointer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, _objectSpread({
                    display: "inline-block",
                    fontSize: "12px",
                    color: "white",
                    textDecoration: "underline",
                    _hover: {
                        color: 'secondary.500'
                    }
                }, props, {
                    children: [
                        children,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                            as: react_icons_hi__WEBPACK_IMPORTED_MODULE_4__/* .HiOutlineExternalLink */ .Hi9,
                            w: 5,
                            h: 5,
                            ml: [
                                1,
                                1,
                                2,
                                2
                            ]
                        })
                    ]
                }))
            })
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
            passHref: true,
            href: href,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kC, {
                alignItems: "flex-start",
                cursor: "pointer",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xv, _objectSpread({
                    display: "inline-block",
                    fontSize: "12px",
                    color: "white",
                    textDecoration: "underline",
                    _hover: {
                        color: 'secondary.500'
                    }
                }, props, {
                    children: children
                }))
            })
        })
    });
};



/***/ }),

/***/ 81241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "$": function() { return /* binding */ Footer; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/react-icons/fa/index.esm.js
var index_esm = __webpack_require__(45666);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(53857);
// EXTERNAL MODULE: ./node_modules/next-translate/lib/esm/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(62044);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/chakra-ui-accordion.esm.js
var chakra_ui_accordion_esm = __webpack_require__(37816);
;// CONCATENATED MODULE: ./src/components/atoms/accordion/index.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Accordion = function(_param) /*#__PURE__*/ {
    var label = _param.label, children = _param.children, props = _objectWithoutProperties(_param, [
        "label",
        "children"
    ]);
    return (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* Accordion */.UQ, _objectSpread({
        allowToggle: true
    }, props, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionItem */.Qd, {
            border: 0,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_accordion_esm/* AccordionButton */.KF, {
                    _focus: {
                        boxShadow: '0 0'
                    },
                    color: "white",
                    p: 0,
                    fontSize: "xs",
                    _hover: {
                        color: 'purple.100'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                            children: label
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* AccordionIcon */.XE, {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_accordion_esm/* AccordionPanel */.Hk, {
                    p: 0,
                    children: children
                })
            ]
        })
    }));
};


// EXTERNAL MODULE: ./src/components/atoms/link/index.tsx
var atoms_link = __webpack_require__(82452);
;// CONCATENATED MODULE: ./src/components/molecules/footer/links/index.tsx




var FooterLinks = function(param) {
    var title = param.title, footerLinks = param.footerLinks;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
            alignItems: {
                base: 'flex-start',
                md: 'center'
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                    color: "white",
                    fontSize: "sm",
                    fontWeight: 700,
                    textAlign: "start",
                    textTransform: "uppercase",
                    w: 40,
                    mb: 4,
                    children: title
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                    flexDir: "column",
                    children: footerLinks.map(function(link) {
                        if (link.subPaths && link.subPaths.length > 0) {
                            return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion, {
                                label: link.label,
                                w: 40,
                                mb: 4,
                                children: link.subPaths.map(function(subLink) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(atoms_link/* Link */.r, {
                                        "data-testid": "footer-link",
                                        href: subLink.path || '',
                                        mt: 4,
                                        textAlign: "start",
                                        textDecoration: "none",
                                        w: 40,
                                        fontSize: "xs",
                                        _hover: {
                                            color: 'purple.100'
                                        },
                                        children: subLink.label
                                    }, subLink.label);
                                })
                            }, link.label));
                        }
                        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_link/* Link */.r, {
                            "data-testid": "footer-link",
                            href: link.path || '',
                            mb: 4,
                            textAlign: "start",
                            textDecoration: "none",
                            fontSize: "xs",
                            _hover: {
                                color: 'purple.100'
                            },
                            external: link.external,
                            children: link.label
                        }, link.label));
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(95196);
;// CONCATENATED MODULE: ./src/components/molecules/footer/linkIcons/index.tsx


var FooterLinksIcons = function(param) {
    var footerIconLinks = param.footerIconLinks;
    /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
            w: {
                base: '100%',
                md: 'auto'
            },
            justify: {
                base: 'flex-start',
                md: 'flex-start'
            },
            children: footerIconLinks.map(function(link) {
                /*#__PURE__*/ return (0,jsx_runtime.jsx)("a", {
                    target: "_blank",
                    href: link.path,
                    "data-testid": "footer-icon-link",
                    rel: "noopener noreferrer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                        display: "inline-block",
                        fontSize: "12px",
                        color: "white",
                        textDecoration: "underline",
                        _hover: {
                            color: 'purple.100'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                            as: link.icon,
                            borderRadius: "2px",
                            h: 4,
                            mb: -2,
                            mr: 4,
                            w: 4
                        })
                    })
                }, link.path);
            })
        })
    });
};

// EXTERNAL MODULE: ./src/lib/constants/paths.ts
var paths = __webpack_require__(29770);
// EXTERNAL MODULE: ./src/components/atoms/images/geekLogo/index.tsx + 3 modules
var geekLogo = __webpack_require__(54209);
// EXTERNAL MODULE: ./src/lib/constants/translateNamespaces.ts
var translateNamespaces = __webpack_require__(8366);
;// CONCATENATED MODULE: ./src/components/organisms/footer/index.tsx










var forDevsLinks = [
    {
        label: 'Blog de TI',
        path: paths/* BLOG_TECH */.QN,
        external: true
    },
    {
        label: 'Vagas de tecnologia',
        subPaths: [
            {
                label: 'Vagas javascript',
                path: paths/* JOBS_JAVASCRIPT */.Sn
            },
            {
                label: 'Vagas java',
                path: paths/* JOBS_JAVA */.k8
            },
            {
                label: 'Vagas node.js',
                path: paths/* JOBS_NODEJS */.bk
            },
            {
                label: 'Vagas PHP',
                path: paths/* JOBS_PHP */.UV
            },
            {
                label: 'Vagas react',
                path: paths/* JOBS_REACT */.a5
            },
            {
                label: 'Vagas python',
                path: paths/* JOBS_PYTHON */.KB
            }, 
        ]
    }, 
];
var forCompaniesLinks = [
    {
        label: 'Blog de RH Tech',
        path: paths/* BLOG_RHTECH */.nr,
        external: true
    },
    {
        label: 'Tech Recruiter as a Service',
        path: paths/* TRAAS */.Nt,
        external: false
    },
    {
        label: 'GeekAcademy',
        path: paths/* GEEK_ACADEMY */.Aj,
        external: true
    },
    {
        label: 'Comece a contratar',
        path: paths/* COMPANY_LP */.NL,
        external: false
    }, 
];
var geekhunterLinks = [
    {
        label: 'Sobre a GeekHunter',
        path: paths/* ABOUT */.FA
    },
    {
        label: 'Suporte',
        path: paths/* HELP */.Ms
    },
    {
        label: 'Pol\xedtica de privacidade',
        path: paths/* POLITICS */.Zp
    },
    {
        label: 'Termos de uso',
        path: paths/* TERMS */.WF
    },
    {
        label: 'Portal LGPD',
        path: paths/* DATA_PRIVACY */.hz
    }, 
];
var footerIconLinks = [
    {
        icon: ai_index_esm/* AiFillInstagram */.t0C,
        path: paths/* INSTAGRAM */.Er
    },
    {
        icon: index_esm/* FaLinkedin */.ltd,
        path: paths/* LINKEDIN */.fW
    },
    {
        icon: index_esm/* FaYoutube */.V2E,
        path: paths/* YOUTUBE */.VU
    }, 
];
var Footer = function() {
    var t = (0,useTranslation/* default */.Z)(translateNamespaces/* TRANSLATE_NAMESPACES.plataformFooter */.V.plataformFooter).t;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        as: "footer",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                bgColor: "black",
                flexDir: {
                    base: 'column',
                    md: 'row'
                },
                justify: "space-evenly",
                p: 16,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
                        alignItems: "flex-start",
                        mb: {
                            base: 16,
                            md: 0
                        },
                        spacing: 4,
                        w: 40,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(geekLogo/* default */.Z, {
                                type: "horizontal"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                fontSize: "xs",
                                color: "white",
                                children: [
                                    "Rod. Jos\xe9 Carlos Daux - SC",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "401, 4120 - km 4, Bairro Saco",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "Grande - Florian\xf3polis - SC",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "CEP 88032-005"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                        gap: {
                            base: 16,
                            md: 4
                        },
                        templateColumns: {
                            base: 'repeat(1, 1fr)',
                            md: 'repeat(3, 1fr)'
                        },
                        w: {
                            base: '100%',
                            md: '60%'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks, {
                                title: "Para Profissionais",
                                footerLinks: forDevsLinks
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks, {
                                title: "Para empresas",
                                footerLinks: forCompaniesLinks
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinks, {
                                title: "A Geekhunter",
                                footerLinks: geekhunterLinks
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                borderTopWidth: 1,
                borderTopStyle: "solid",
                borderTopColor: "black.600",
                bgColor: "black",
                gap: 8,
                px: 16,
                py: 4,
                templateColumns: [
                    'repeat(1, 1fr)',
                    'repeat(2, 1fr)'
                ],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLinksIcons, {
                        footerIconLinks: footerIconLinks
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                        color: "grey.300",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                            alignItems: "flex-start",
                            justify: "flex-end",
                            fontSize: "xs",
                            color: "white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                    mr: {
                                        base: 0,
                                        md: 1
                                    },
                                    children: [
                                        "\xa9 2015 - ".concat(new Date().getFullYear(), " "),
                                        t('geekhunter'),
                                        ". "
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "Todos os direitos reservados."
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    }));
};


/***/ }),

/***/ 28147:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landingPageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(8014);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(75657);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(75332);
// EXTERNAL MODULE: ./node_modules/react-cookie/es6/useCookies.js + 1 modules
var useCookies = __webpack_require__(15579);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/hooks/dist/chakra-ui-hooks.esm.js
var chakra_ui_hooks_esm = __webpack_require__(27446);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(34237);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/chakra-ui-icon.esm.js
var chakra_ui_icon_esm = __webpack_require__(95196);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/chakra-ui-modal.esm.js + 56 modules
var chakra_ui_modal_esm = __webpack_require__(25215);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.esm.js
var index_esm = __webpack_require__(50167);
// EXTERNAL MODULE: ./src/components/atoms/images/geekLogo/index.tsx + 3 modules
var geekLogo = __webpack_require__(54209);
// EXTERNAL MODULE: ./src/components/atoms/headerLinkLabel/index.tsx
var headerLinkLabel = __webpack_require__(55098);
;// CONCATENATED MODULE: ./src/components/atoms/headerLinkButton/index.tsx


function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var HeaderLinkButton = function(_param) {
    var _isSelected = _param.isSelected, isSelected = _isSelected === void 0 ? false : _isSelected, children = _param.children, props = _objectWithoutProperties(_param, [
        "isSelected",
        "children"
    ]);
    var selectedStyle = {
        bgColor: 'primary.300',
        borderColor: 'primary.300',
        color: 'primary.50'
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, _objectSpread({
        _hover: selectedStyle,
        bgColor: "primary.500",
        borderWidth: 2,
        borderColor: "primary.500",
        borderRadius: "base",
        color: "white.100",
        cursor: "pointer",
        fontFamily: "body",
        fontSize: 10,
        fontWeight: "700",
        letterSpacing: 1.2,
        ml: 8,
        px: 6,
        paddingTop: 1.5,
        paddingBottom: 1,
        sx: isSelected ? selectedStyle : {},
        textTransform: "uppercase",
        transition: "0.2s"
    }, props, {
        children: children
    })));
};
/* harmony default export */ var headerLinkButton = (HeaderLinkButton);

// EXTERNAL MODULE: ./src/lib/constants/paths.ts
var paths = __webpack_require__(29770);
// EXTERNAL MODULE: ./src/lib/constants/auth.ts
var auth = __webpack_require__(70333);
// EXTERNAL MODULE: ./src/lib/constants/cookies.ts
var constants_cookies = __webpack_require__(12062);
;// CONCATENATED MODULE: ./src/components/organisms/landingPageHeader/index.tsx












function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var LandingPageHeader = function(param) {
    var headerLinks = param.headerLinks, _featuredLogin = param.featuredLogin, featuredLogin = _featuredLogin === void 0 ? false : _featuredLogin;
    var ref = (0,chakra_ui_hooks_esm/* useDisclosure */.qY)(), isOpen = ref.isOpen, onOpen = ref.onOpen, onClose = ref.onClose;
    var router = (0,next_router.useRouter)();
    var ref1 = _slicedToArray((0,useCookies/* default */.Z)([
        auth/* AUTH_TOKEN */.UA,
        constants_cookies/* USER_TYPE */.$A
    ]), 1), cookies = ref1[0];
    var dashboardLink = (0,paths/* DASHBOARD */.h1)(cookies.user_type);
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
        bg: "white",
        position: "fixed",
        zIndex: 10,
        left: 0,
        top: 0,
        w: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
            justify: "space-between",
            alignItems: "center",
            p: "16px 32px",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                    href: paths/* ROOT */.Dx,
                    cursor: "pointer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(geekLogo/* default */.Z, {})
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    display: [
                        'none',
                        'none',
                        'flex',
                        'flex'
                    ],
                    children: [
                        headerLinks.map(function(link) {
                            /*#__PURE__*/ return (0,jsx_runtime.jsx)(next_link["default"], {
                                passHref: true,
                                href: {
                                    pathname: link.path
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                    children: link.isFeatured ? /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkButton, {
                                        isSelected: router.asPath.includes(link.path),
                                        children: link.label
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkLabel/* default */.Z, {
                                        isSelected: router.asPath.includes(link.path),
                                        children: link.label
                                    })
                                })
                            }, link.path);
                        }),
                        cookies.auth_token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            passHref: true,
                            href: dashboardLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkLabel/* default */.Z, {
                                    isSelected: router.asPath.includes(dashboardLink),
                                    children: "Entrar"
                                })
                            })
                        }) : null,
                        !cookies.auth_token && featuredLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            passHref: true,
                            href: paths/* LOGIN */.ym,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkButton, {
                                    isSelected: router.asPath.includes(paths/* LOGIN */.ym),
                                    children: "Login"
                                })
                            })
                        }) : null,
                        !cookies.auth_token && !featuredLogin ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                            passHref: true,
                            href: paths/* LOGIN */.ym,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkLabel/* default */.Z, {
                                    isSelected: router.asPath.includes(paths/* LOGIN */.ym),
                                    children: "Login"
                                })
                            })
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_icon_esm/* Icon */.JO, {
                    color: "black",
                    as: index_esm/* FiMenu */.cur,
                    display: [
                        'block',
                        'block',
                        'none',
                        'none'
                    ],
                    w: 6,
                    h: 6,
                    onClick: onOpen
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* Drawer */.dy, {
                    isFullHeight: false,
                    placement: "right",
                    onClose: onClose,
                    isOpen: isOpen,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerOverlay */.P1, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_modal_esm/* DrawerContent */.sc, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerCloseButton */.cC, {
                                    top: 6,
                                    right: 6,
                                    color: "black"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_modal_esm/* DrawerBody */.Ng, {
                                    px: 0,
                                    py: 20,
                                    bgColor: "white",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Grid */.rj, {
                                        templateColumns: "repeat(1, 1fr)",
                                        gap: 6,
                                        children: [
                                            headerLinks.map(function(link) {
                                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                        passHref: true,
                                                        href: link.path,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkLabel/* default */.Z, {
                                                                isSelected: router.asPath.includes(link.path),
                                                                children: link.label
                                                            })
                                                        })
                                                    })
                                                }, link.path);
                                            }),
                                            cookies.auth_token ? /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    passHref: true,
                                                    href: dashboardLink,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkLabel/* default */.Z, {
                                                            isSelected: router.asPath.includes(dashboardLink),
                                                            children: "Dashboard"
                                                        })
                                                    })
                                                })
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* GridItem */.P4, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                                                    passHref: true,
                                                    href: paths/* LOGIN */.ym,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(headerLinkLabel/* default */.Z, {
                                                            isSelected: router.asPath.includes(paths/* LOGIN */.ym),
                                                            children: "Login"
                                                        })
                                                    })
                                                })
                                            }, paths/* LOGIN */.ym)
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    }));
};
/* harmony default export */ var landingPageHeader = (LandingPageHeader);


/***/ }),

/***/ 71458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gb": function() { return /* binding */ headerLinks; }
/* harmony export */ });
/* unused harmony export companiesLPHeaderLinks */
/* harmony import */ var lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29770);

var headerLinks = [
    {
        isFeatured: false,
        label: 'Vagas',
        path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .JOBS */ .WN
    },
    {
        isFeatured: false,
        label: 'Para Profissionais',
        path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .CANDIDATE_LP */ .Is
    },
    {
        isFeatured: true,
        label: 'sou empresa',
        path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_LP */ .NL
    }, 
];
// backward compatibility with old sign up flow pages
var companiesLPHeaderLinks = [
    {
        isFeatured: false,
        label: 'Para empresas',
        path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_LP */ .NL
    },
    {
        isFeatured: false,
        label: 'Para Profissionais',
        path: lib_constants_paths__WEBPACK_IMPORTED_MODULE_0__/* .CANDIDATE_LP */ .Is
    }, 
];
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (headerLinks)));


/***/ })

}]);